import { useQuery } from '@apollo/react-hooks'
import {
  Breadcrumbs,
  colors,
  Divider,
  LinearProgress,
  Link,
  Tab,
  Tabs,
  Typography,
} from '@material-ui/core'
import { makeStyles } from '@material-ui/styles'
import { Link as RouterLink } from '@reach/router'
import { gql } from 'apollo-boost'
import PropTypes from 'prop-types'
import React from 'react'
import ErrorMessage from '../../components/ErrorMessage'
import Page from '../../components/Page'
import getIdFromSlug from '../../utils/getIDfromSlug'

const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(3),
  },
  tabs: {
    marginTop: theme.spacing(3),
  },
  divider: {
    backgroundColor: colors.grey[300],
    marginBottom: theme.spacing(3),
  },
  breadcrumb: {
    marginBottom: theme.spacing(2),
  },
}))

const GET_CONTACT = gql`
  query ($id: ID!) {
    contact(id: $id) {
      id
      slug
      firstName
      lastName
      fullName
      phoneNumber
      email
      type
      title
    }
  }
`

const ContactDetails = (props) => {
  const classes = useStyles()
  const { slug, children, location } = props
  const id = getIdFromSlug(slug)
  const { data, loading, error } = useQuery(GET_CONTACT, {
    variables: { id: id },
    fetchPolicy: 'no-cache',
  })

  const tabs = [
    { value: 'summary', label: 'Oversikt' },
    { value: 'enrollments', label: 'Påmeldinger' },
  ]

  const pathArray = location.pathname.split('/')
  const lastPartOfPath = pathArray[pathArray.length - 1]

  const currentTab =
    tabs.map((item) => item.value).indexOf(lastPartOfPath) === -1 ? 'summary' : lastPartOfPath

  if (loading) return <LinearProgress color="secondary" />
  if (error) return <ErrorMessage>{error.message}</ErrorMessage>

  const { contact } = data

  return (
    <Page className={classes.root} title={`Elever og lærere - ${contact.fullName}`}>
      <Breadcrumbs aria-label="breadcrumb" className={classes.breadcrumb}>
        <Link component={RouterLink} variant="subtitle1" color="textPrimary" to="/">
          Hjem
        </Link>
        <Link component={RouterLink} variant="subtitle1" color="textPrimary" to="/contacts">
          Elever og lærere
        </Link>
      </Breadcrumbs>
      <Typography component="h1" variant="h3">
        {contact.fullName}
      </Typography>

      <Tabs className={classes.tabs} scrollButtons="auto" value={currentTab} variant="scrollable">
        {tabs.map((tab) => (
          <Tab
            key={tab.value}
            label={tab.label}
            value={tab.value}
            component={RouterLink}
            to={tab.value}
          />
        ))}
      </Tabs>
      <Divider className={classes.divider} />
      {children}
    </Page>
  )
}

ContactDetails.propTypes = {
  slug: PropTypes.string,
}

export default ContactDetails
